<template>
    <div class="mid">
        <b-link
            class="back"
            @click="$emit('proceed', 'permissions')"
            ><svg-icon icon="back"
        /></b-link>
        <h1>{{ $t('aiSetupTitle') }}</h1>
        <p class="text-center">{{ $t('aiSetupText1') }}</p>
        <div class="previewVideo">
            <img
                v-if="ready || (loading && capturedPreview)"
                :src="ready ? baseFace : capturedPreview"
                alt="AI capture preview"
            />
            <video
                v-else
                ref="video"
                autoplay
                muted
                playsinline
            ></video>
            <div
                v-if="countdown || ready || loading"
                class="overlay"
            >
                <span
                    v-if="countdown"
                    class="countdown"
                    >{{ countdown }}</span
                >
                <LoadingSpinner v-if="loading && !ready" />
                <span
                    v-if="ready"
                    class="ready"
                >
                    <svg-icon
                        icon="check"
                        width="128"
                        height="128"
                    />
                </span>
            </div>
        </div>
        <p v-if="!ready" class="text-center">{{ $t('aiSetupText2') }}</p>
        <p v-if="ready" class="text-center">{{ $t('aiSetupSuccess') }}</p>
        <p v-if="error" class="text-center text-danger">{{ $t(error) }}</p>
        <b-button
            v-if="!ready"
            class="p-3 mt-3"
            block
            variant="primary"
            @click="capture"
            :disabled="countdownTimer > 0 || loading"
            >{{ $t('aiSetupButton') }}</b-button
        >
        
        <b-button
            v-if="ready"
            class="p-3"
            block
            variant="primary"
            @click="$emit('proceed', 'intro')"
            >{{ $t('continue') }}</b-button
        >
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon';
import LoadingSpinner from '@/components/loader/Loader';

export default {
    name: 'AssessmentAI',
    components: {
        SvgIcon,
        LoadingSpinner,
    },
    props: {
        cameraStream: MediaStream,
        error: String,
        ready: Boolean,
        baseFace: String,
        aiReady: Boolean,
    },
    data() {
        return {
            countdown: 0,
            countdownTimer: null,
            loading: false,
            capturedPreview: null,
        };
    },
    watch: {
        cameraStream(newVal) {
            this.bindVideoStream(newVal);
        },
        error() {
            if (this.error) {
                this.loading = false;
                this.capturedPreview = null;
            }   
        },
        ready() {
            if (this.ready) {
                this.loading = false;
                this.capturedPreview = null;
            }
        },
        capturedPreview(newVal, oldVal) {
            if (!newVal && oldVal) {
                this.$nextTick(() => {
                    this.bindVideoStream(this.cameraStream);
                });
            }
        }
    },
    mounted() {
        this.bindVideoStream(this.cameraStream);
    },
    methods: {
        bindVideoStream(stream) {
            if (stream && this.$refs.video) {
                this.$refs.video.srcObject = stream;
            }
        },
        captureFrame(video) {
            if (!video) {
                return null;
            }

            const width = video.videoWidth || video.clientWidth;
            const height = video.videoHeight || video.clientHeight;

            if (!width || !height) {
                return null;
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const context = canvas.getContext('2d');
            if (!context) {
                return null;
            }

            context.drawImage(video, 0, 0, width, height);
            return canvas;
        },
        capture() {
            this.countdown = 3;
            const tick = async () => {
                if (this.countdown > 1) {
                    this.countdown--;
                    this.countdownTimer = setTimeout(tick, 1000);
                } else {
                    this.countdown = 0;
                    this.countdownTimer = null;
                    const capturedFrame = this.captureFrame(this.$refs.video);
                    this.capturedPreview = capturedFrame ? capturedFrame.toDataURL('image/png') : null;
                    this.loading = true;
                    this.$emit('capture', {
                        video: this.$refs.video,
                        capturedFrame,
                    });
                }
            };
            tick();
        },
    },
};
</script>
